import { render, staticRenderFns } from "./input-element.vue?vue&type=template&id=6b3e84d8&scoped=true&"
import script from "./input-element.vue?vue&type=script&lang=ts&"
export * from "./input-element.vue?vue&type=script&lang=ts&"
import style0 from "./input-element.vue?vue&type=style&index=0&id=6b3e84d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e84d8",
  null
  
)

export default component.exports